// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"7edc40f5","321":"0badb4ee","323":"352b3c55","485":"f1a5fd9a","526":"ba99d218","592":"639eda9f","773":"c24b4a9e","834":"ce56ac96"}[chunkId] + ".chunk.js";
};